<template>
  <div class="search-trigger">
    <!-- Desktop Search Button -->
    <v-btn
      icon
      variant="text"
      color="logo-color"
      @click="openSearch"
      class="search-icon-btn"
      aria-label="Abrir busca"
    >
      <v-icon>mdi-magnify</v-icon>
    </v-btn>
  </div>
</template>

<script setup>
// Emits
const emit = defineEmits(['open-search'])

// Methods
const openSearch = () => {
  emit('open-search')
}
</script>

<style scoped>
.search-trigger {
  display: flex;
  align-items: center;
}

.search-icon-btn {
  transition: all 0.2s ease;
}

.search-icon-btn:hover {
  background-color: rgba(254, 243, 199, 0.1);
  transform: scale(1.05);
}

.search-icon-btn .v-icon {
  color: #FEF3C7E6;
}
</style>